<template>
  <div
    class="channels-tab"
    :class="{ '--even': tab.cardList?.length % 2 === 0 }"
  >
    <div class="channels-tab__image">
      <picture>
        <source
          :srcset="
            require(`@/assets/img/faq_and_support/channels/${tab.image}--mobile.jpg`)
          "
          type="image/jpeg"
          media="(max-width: 991px)"
        />
        <source
          :srcset="
            require(`@/assets/img/faq_and_support/channels/${tab.image}--mobile.webp`)
          "
          type="image/webp"
          media="(max-width: 991px)"
        />
        <source
          :srcset="
            require(`@/assets/img/faq_and_support/channels/${tab.image}.jpg`)
          "
          type="image/jpeg"
        />
        <img
          :src="
            require(`@/assets/img/faq_and_support/channels/${tab.image}.webp`)
          "
          alt=""
          loading="lazy"
        />
      </picture>
    </div>
    <div
      v-for="card in tab.cardList"
      :key="card.id"
      class="channel-card"
      :class="`--${card.type}`"
    >
      <picture v-if="card.type === 'main'">
        <source
          srcset="@/assets/img/faq_and_support/channels/cursor.png"
          type="image/png"
        />
        <img
          src="@/assets/img/faq_and_support/channels/cursor.webp"
          alt=""
          width="70"
          height="70"
          loading="lazy"
        />
      </picture>
      <p class="channel-card__title">{{ card.title }}</p>
      <p class="channel-card__description" v-html="card.description"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FaqAndSupportChannelsTabContent',
  props: {
    tab: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style scoped lang="scss">
.channels-tab {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, minmax(192px, auto));
  gap: 8px;
  font-family: $font-mts-compact;

  @include screen-down('lg') {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(6, 82px);
  }

  @include screen-down('sm') {
    grid-template-columns: 1fr;
    grid-template-rows: minmax(326px, auto);
    grid-auto-rows: minmax(170px, auto);
  }

  &.--even {
    .channels-tab__image {
      @include screen-up('lg') {
        grid-row: 1;
      }
    }

    .channel-card {
      @include screen-between('sm', 'lg') {
        grid-row: span 2;
      }
    }
  }

  .channel-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 16px 32px;
    border-radius: 24px;
    background-color: $color-white;

    @include screen-down('xl') {
      padding: 16px 24px;
    }

    @include screen-between('sm', 'lg') {
      grid-row: span 3;
    }

    &__title {
      font-family: $font-mts-wide;
      font-size: 44px;
      line-height: 44px;
      font-weight: 500;
      text-align: center;

      @include screen-down('xl') {
        font-size: 36px;
        line-height: 36px;
      }

      @include screen-down('md') {
        font-size: 34px;
        line-height: 34px;
      }
    }

    &__description {
      font-size: 24px;
      line-height: 32px;
      text-align: center;

      @include screen-down('xl') {
        font-size: 20px;
        line-height: 28px;
      }

      @include screen-between('sm', 'md') {
        font-size: 18px;
        line-height: 24px;
      }
    }

    &.--main {
      align-items: flex-start;
      padding: 32px;

      @include screen-down('xl') {
        padding: 24px;
      }

      @include screen-up('lg') {
        grid-row: 1 / span 2;
      }

      @include screen-between('sm', 'lg') {
        grid-row: 1 / span 4;
      }

      .channel-card__title {
        max-width: 360px;
        font-size: 30px;
        line-height: 34px;
        letter-spacing: -0.01em;
        text-align: left;

        @include screen-down('xl') {
          font-size: 26px;
          line-height: 30px;
        }
      }

      img {
        display: block;

        @include screen-down('xl') {
          width: 60px;
          height: 60px;
        }
      }

      .channel-card__description {
        max-width: 312px;
        margin-top: auto;
        text-align: left;

        @include screen-down('sm') {
          max-width: 100%;
          padding-top: 16px;
        }
      }

      &::v-deep a {
        color: $color-dark-2;
        text-decoration: none;
      }
    }

    &.--white {
      .channel-card__title {
        background: linear-gradient(
          96.48deg,
          $color-purple-extra-light -38.17%,
          $color-purple-2 89.44%
        );
        background-clip: text;
        color: transparent;
      }
    }

    &.--gradient {
      background: linear-gradient(
        81.31deg,
        $color-white 9.7%,
        $color-purple-extra-light 49.62%,
        $color-purple-2 169.38%
      );
    }

    &.--yellow {
      background-color: $color-yellow;
    }
  }

  &__image {
    border-radius: 24px;
    overflow: hidden;
    line-height: 0;

    @include screen-up('lg') {
      grid-row: 1 / span 2;
      grid-column: 3;
    }

    @include screen-between('sm', 'lg') {
      grid-row: 5 / span 2;
      grid-column: 1;
    }

    @include screen-down('sm') {
      grid-row: 3;
      max-height: 170px;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
